import React from 'react'
import { Container, Row, Col, Button, FormGroup, Input } from 'reactstrap'
import Logo from './images/logo'
import './styles/Footer.css'
import { MenuList } from './header'
import Icon from './styles/icon';
import vine from './images/vine.svg'

const Footer = () => (
    <div>
        <Container>
            <div className="vine-wrapper">
                    <img src={vine} alt="vine"/>
            </div>
            <Row>
                <Col sm={6} md={3}>
                    <div className="footer">
                        <div className="footer-peacock">
                            
                        </div>
                        <div className="footer-logo">
                            <Logo fill="#f8934a" />
                            <h6>Paithani Park</h6>
                        </div>
                        <i className="short">
                        सर्व प्रकारच्या वस्त्रांसाठी एकमेव खात्रीशीर दालन
                        </i>
                        <div className="footer-address">
                            <div className="tbl-row">
                                <div className="tbl-cell">
                                    <i className="fas fa-mobile-alt"></i>
                                </div>
                                <div className="tbl-cell">
                                    <a href="tel:8855998600">+91 88 55 99 86 00</a>
                                </div>
                            </div>
                            <div className="tbl-row">
                                <div className="tbl-cell">
                                    <Icon icon="fa-map-marker-alt" />
                                </div>
                                <div className="tbl-cell">
                                    <strong>R.K.Nakod Paithani Park,</strong>
                                    <p>Nagar-Manmad Road,</p>
                                    <p>Near Yeola Tehsil</p>
                                    <p>Yeola - 423401</p>
                                </div>
                            </div>
                            <div className="tbl-row">
                                <div className="tbl-cell">
                                    <Icon icon="fa-at" />
                                </div>
                                <div className="tbl-cell">
                                    <a href="mailto:ajay885599@gmail.com">ajay885599@gmail.com</a>
                                </div>
                            </div>
                            <div className="tbl-row">
                                <div className="tbl-cell">
                                    <Icon icon="fa-globe" />
                                </div>
                                <div className="tbl-cell">
                                    <a href="http://www.paithanishopping.com"><i>www.paithanishopping.com</i></a>
                                </div>

                            </div>
                        </div>
                    </div>
                </Col>
                <Col sm={6} md={3}>
                    <div className="footer">
                        <h5>Footer Menu</h5>
                        <MenuList menuClass="footer-menu" />
                    </div>
                </Col>
                <Col sm={6} md={3}>
                    <div className="footer">
                        <h5>We're Social</h5>
                        <div className="map-holder">
                            <div className="map-overlay">
                                <a target="_blank" rel="noopener noreferrer" href="https://goo.gl/maps/q3yjNyjk3RK2" className="btn-map theme-button">
                                    <Icon icon="fa-map-marked-alt" />
                                   &nbsp; Get Directions
                            </a>
                            </div>
                            <div className="map"></div>
                        </div>
                    </div>
                </Col>
                <Col sm={6} md={3}>
                    <div className="footer">
                        <h5>Message Us</h5>
                        {/* <Form> */}
                            <FormGroup>
                                <Input type="text" placeholder="Your Name" />
                            </FormGroup>

                            <FormGroup>
                                <Input type="email" name="email" placeholder="Your Email" />
                            </FormGroup>

                            <FormGroup>
                                <Input type="textarea" name="text" placeholder="Your Message" />
                            </FormGroup>
                            <Button className="theme-button">Send</Button>
                        {/* </Form> */}
                    </div>
                </Col>
            </Row>
        </Container>
        <div className="footer-base">
            2018 | All Rights Reserved | www.paithanishopping.com 
            <i className="footer-company"><a href="http://olsystech.com">Designed By: OLSYS TECHNOLOGIES</a></i>
        </div>
    </div>
)
export default Footer


// WEBPACK FOOTER //
// ./src/Footer.jsx